# Kíli the Resourceful on the battlefield with Chainsaw in hand, and lands to cast it.
PLAYER p1 20 Alice
PLAYER p2 20 Bob
ACTIVE p1
p1 battlefield Kíli the Resourceful
p1 battlefield Mountain
p1 battlefield Mountain
p1 battlefield Forest
p1 hand Chainsaw
p1 library Mountain | copies=10
p2 battlefield Grizzly Bears
p2 battlefield Forest
p2 library Forest | copies=10
